const InkPads = ( $ ) => {
	let currentVariation = null;

	const getSettings = () => {
		const data = window.diviChildData || {};
		return {
			currencySymbol: data.currencySymbol || 'zł',
			decimalSeparator: data.decimalSeparator || ',',
			thousandSeparator: typeof data.thousandSeparator !== 'undefined' ? data.thousandSeparator : ' ',
			decimals: typeof data.decimals !== 'undefined' ? parseInt( data.decimals, 10 ) : 2,
			priceFormat: data.priceFormat || '%2$s&nbsp;%1$s',
		};
	};

	const formatNumber = ( number, decimals, decPoint, thousandsSep ) => {
		const n = isNaN( +number ) ? 0 : +number;
		const prec = isNaN( +decimals ) ? 2 : Math.abs( decimals );
		const sep = typeof thousandsSep === 'undefined' ? ' ' : thousandsSep;
		const dec = typeof decPoint === 'undefined' ? ',' : decPoint;

		const toFixedFix = ( num, precision ) => {
			const k = Math.pow( 10, precision );
			return '' + ( Math.round( num * k ) / k ).toFixed( precision );
		};

		const s = toFixedFix( n, prec ).split( '.' );
		if ( s[ 0 ].length > 3 ) {
			s[ 0 ] = s[ 0 ].replace( /\B(?=(?:\d{3})+(?!\d))/g, sep );
		}
		if ( ( s[ 1 ] || '' ).length < prec ) {
			s[ 1 ] = s[ 1 ] || '';
			s[ 1 ] += new Array( prec - s[ 1 ].length + 1 ).join( '0' );
		}
		return s.join( dec );
	};

	const formatPriceHtml = ( amount ) => {
		const settings = getSettings();
		const formattedNumber = formatNumber( amount, settings.decimals, settings.decimalSeparator, settings.thousandSeparator );
		const symbolHtml = `<span class="woocommerce-Price-currencySymbol" translate="no" dir="auto">${settings.currencySymbol}</span>`;
		const formattedInner = settings.priceFormat
			.replace( '%1$s', symbolHtml )
			.replace( '%2$s', formattedNumber );

		return `<span class="woocommerce-Price-amount amount"><bdi>${formattedInner}</bdi></span>`;
	};

	const parseAmount = ( text ) => {
		if ( ! text ) {
			return 0;
		}
		const cleaned = text.toString().replace( /\u00a0|&nbsp;|\s/g, '' ).replace( ',', '.' );
		const match = cleaned.match( /\d+(?:\.\d+)?/ );
		return match ? parseFloat( match[ 0 ] ) : 0;
	};

	const getSelectedInkPadPrice = () => {
		const $checked = $( '.ink-pads-block input[type="radio"][name="ink_pad"]:checked:visible' );
		if ( ! $checked.length ) {
			return 0;
		}
		const priceAttr = $checked.data( 'price' ) || $checked.attr( 'data-price' );
		return priceAttr ? parseFloat( priceAttr ) || 0 : 0;
	};

	const updateProductPrice = () => {
		const inkPadPrice = getSelectedInkPadPrice();
		const $priceModules = $( '.et_pb_wc_price' );

		if ( ! $priceModules.length ) {
			return;
		}

		$priceModules.each( function() {
			const $module = $( this );
			const $priceElem = $module.find( '.price' ).length ? $module.find( '.price' ) : $module;

			if ( typeof $module.data( 'initial-price-html' ) === 'undefined' ) {
				$module.data( 'initial-price-html', $priceElem.html() );
			}

			if ( typeof $module.data( 'initial-price-data' ) === 'undefined' ) {
				const $del = $priceElem.find( 'del' );
				const $ins = $priceElem.find( 'ins' );
				const $amounts = $priceElem.find( '.amount' );

				let priceData = { type: 'single', price: 0 };

				if ( $del.length && $ins.length ) {
					priceData = {
						type: 'sale',
						regularPrice: parseAmount( $del.text() ),
						salePrice: parseAmount( $ins.text() ),
					};
				} else if ( $amounts.length > 1 ) {
					priceData = {
						type: 'range',
						minPrice: parseAmount( $amounts.eq( 0 ).text() ),
						maxPrice: parseAmount( $amounts.eq( 1 ).text() ),
					};
				} else if ( $amounts.length === 1 ) {
					priceData = {
						type: 'single',
						price: parseAmount( $amounts.eq( 0 ).text() ),
					};
				}
				$module.data( 'initial-price-data', priceData );
			}

			const initialHtml = $module.data( 'initial-price-html' );
			const initialData = $module.data( 'initial-price-data' );

			if ( currentVariation ) {
				const displayPrice = typeof currentVariation.display_price !== 'undefined' ? parseFloat( currentVariation.display_price ) : 0;
				const regularPrice = typeof currentVariation.display_regular_price !== 'undefined' ? parseFloat( currentVariation.display_regular_price ) : displayPrice;
				const isOnSale = regularPrice > displayPrice;

				if ( inkPadPrice > 0 ) {
					if ( isOnSale ) {
						const totalRegular = regularPrice + inkPadPrice;
						const totalSale = displayPrice + inkPadPrice;
						$priceElem.html( `<del aria-hidden="true">${formatPriceHtml( totalRegular )}</del> <ins>${formatPriceHtml( totalSale )}</ins>` );
					} else {
						const totalPrice = displayPrice + inkPadPrice;
						$priceElem.html( formatPriceHtml( totalPrice ) );
					}
				} else {
					if ( currentVariation.price_html && currentVariation.price_html.trim() !== '' ) {
						$priceElem.html( currentVariation.price_html );
					} else if ( isOnSale ) {
						$priceElem.html( `<del aria-hidden="true">${formatPriceHtml( regularPrice )}</del> <ins>${formatPriceHtml( displayPrice )}</ins>` );
					} else {
						$priceElem.html( formatPriceHtml( displayPrice ) );
					}
				}
				return;
			}

			if ( inkPadPrice > 0 ) {
				if ( initialData.type === 'sale' ) {
					const totalRegular = initialData.regularPrice + inkPadPrice;
					const totalSale = initialData.salePrice + inkPadPrice;
					$priceElem.html( `<del aria-hidden="true">${formatPriceHtml( totalRegular )}</del> <ins>${formatPriceHtml( totalSale )}</ins>` );
				} else if ( initialData.type === 'range' ) {
					const totalMin = initialData.minPrice + inkPadPrice;
					const totalMax = initialData.maxPrice + inkPadPrice;
					$priceElem.html( `${formatPriceHtml( totalMin )} &ndash; ${formatPriceHtml( totalMax )}` );
				} else {
					const totalPrice = initialData.price + inkPadPrice;
					$priceElem.html( formatPriceHtml( totalPrice ) );
				}
			} else {
				$priceElem.html( initialHtml );
			}
		} );
	};

	const syncInkPadToCartForm = () => {
		const $checked = $( '.ink-pads-block input[type="radio"][name="ink_pad"]:checked:visible' );
		const $cartForm = $( 'form.cart' );

		if ( ! $cartForm.length ) {
			return;
		}

		let $hidden = $cartForm.find( 'input[type="hidden"].js-ink-pad-input' );

		if ( $checked.length && $checked.val() ) {
			if ( ! $hidden.length ) {
				$hidden = $( '<input>', {
					type: 'hidden',
					name: 'ink_pad',
					class: 'js-ink-pad-input',
				} ).appendTo( $cartForm );
			}
			$hidden.val( $checked.val() );
		} else {
			$hidden.remove();
		}
	};

	const normalizeSize = ( size ) => {
		if ( ! size ) {
			return '';
		}
		return size.toString().toLowerCase().replace( /[\s-]+/g, '' );
	};

	const getSelectedSize = ( $form ) => {
		const $targetForm = ( $form && $form.length ) ? $form : $( 'form.variations_form' );
		if ( ! $targetForm.length ) {
			return '';
		}

		// 1. Check select value for attribute_*rozmiar*
		const $select = $targetForm.find( 'select[name*="rozmiar"], select[data-attribute_name*="rozmiar"]' );
		if ( $select.length && $select.val() ) {
			return normalizeSize( $select.val() );
		}

		// 2. Check active swatch for attribute_*rozmiar*
		const $swatch = $targetForm.find( '.variable-items-wrapper[data-attribute_name*="rozmiar"] .variable-item.selected, .variable-item.selected[data-attribute_name*="rozmiar"], .variable-item[aria-checked="true"][data-attribute_name*="rozmiar"]' );
		if ( $swatch.length ) {
			const val = $swatch.data( 'value' ) || $swatch.attr( 'data-value' ) || $swatch.data( 'wvstooltip' ) || $swatch.attr( 'title' );
			if ( val ) {
				return normalizeSize( val );
			}
		}

		return '';
	};

	const filterInkPadsBySize = ( $form, explicitSize ) => {
		const $block = $( '.ink-pads-block' );
		if ( ! $block.length ) {
			return;
		}

		const $options = $block.find( '.yith-wapo-option' );
		if ( ! $options.length ) {
			return;
		}

		let size = explicitSize;
		if ( typeof size === 'undefined' || size === null ) {
			size = getSelectedSize( $form );
		}
		const normalizedSize = normalizeSize( size );

		let visibleCount = 0;

		$options.each( function() {
			const $opt = $( this );
			const padSizesAttr = ( $opt.data( 'sizes' ) || $opt.attr( 'data-sizes' ) || '' ).toString();
			const padSizes = padSizesAttr.split( ',' ).map( ( s ) => normalizeSize( s ) ).filter( Boolean );

			const matches = ! normalizedSize || padSizes.length === 0 || padSizes.includes( normalizedSize );

			if ( matches ) {
				$opt.show();
				visibleCount++;
			} else {
				$opt.hide();
				const $radio = $opt.find( 'input[type="radio"][name="ink_pad"]' );
				if ( $radio.is( ':checked' ) ) {
					$radio.prop( 'checked', false );
					$radio.data( 'was-checked', false );
				}
			}
		} );

		if ( visibleCount > 0 ) {
			$block.show();
		} else {
			$block.hide();
		}

		syncInkPadToCartForm();
		updateProductPrice();
	};

	// Allow unchecking/toggling radio button when clicking an already checked radio
	$( document ).on( 'click', '.ink-pads-block input[type="radio"][name="ink_pad"]', function() {
		const $this = $( this );
		if ( $this.data( 'was-checked' ) === true ) {
			this.checked = false;
			$this.data( 'was-checked', false );
			$this.trigger( 'change' );
		} else {
			$( '.ink-pads-block input[type="radio"][name="ink_pad"]' ).data( 'was-checked', false );
			$this.data( 'was-checked', true );
			$this.trigger( 'change' );
		}
	} );

	// Clicking image container activates the corresponding radio
	$( document ).on( 'click', '.ink-pads-block .image-container', function() {
		const forId = $( this ).attr( 'for' );
		if ( forId ) {
			$( `#${forId}` ).trigger( 'click' );
		}
	} );

	// Handle swatch clicks in variation form
	$( document ).on( 'click', 'form.variations_form .variable-item', function() {
		const $form = $( this ).closest( 'form.variations_form' );
		setTimeout( () => {
			filterInkPadsBySize( $form );
		}, 10 );
	} );

	// Handle select changes in variation form
	$( document ).on( 'change', 'form.variations_form select', function() {
		const $form = $( this ).closest( 'form.variations_form' );
		filterInkPadsBySize( $form );
	} );

	// Handle WooCommerce variation events
	$( document ).on( 'found_variation', 'form.variations_form', function( event, variation ) {
		currentVariation = variation;
		let size = '';
		if ( variation && variation.attributes ) {
			for ( const key in variation.attributes ) {
				if ( Object.prototype.hasOwnProperty.call( variation.attributes, key ) && key.indexOf( 'rozmiar' ) !== -1 ) {
					size = variation.attributes[ key ];
					break;
				}
			}
		}
		filterInkPadsBySize( $( this ), size );
		updateProductPrice();
	} );

	$( document ).on( 'reset_data', 'form.variations_form', function() {
		currentVariation = null;
		filterInkPadsBySize( $( this ), '' );
		updateProductPrice();
	} );

	$( document ).on( 'woocommerce_variation_has_changed woocommerce_variation_select_change check_variations', 'form.variations_form', function() {
		filterInkPadsBySize( $( this ) );
	} );

	// Re-filter and re-sync when YITH WAPO reloads addons
	$( document ).on( 'yith-wapo-after-reload-addons', 'form.cart', function() {
		filterInkPadsBySize( $( 'form.variations_form' ) );
		syncInkPadToCartForm();
		updateProductPrice();
	} );

	$( document ).on( 'change', '.ink-pads-block input[type="radio"][name="ink_pad"]', function() {
		syncInkPadToCartForm();
		updateProductPrice();
	} );

	$( document ).on( 'submit', 'form.cart', syncInkPadToCartForm );

	// Initial filter and sync on DOM ready
	filterInkPadsBySize( $( 'form.variations_form' ) );
	updateProductPrice();
};

export default ( ( $ ) => $( InkPads ) )( jQuery );
